import React from 'react';
import { Link } from 'react-router-dom'
import pdf from '../resume/ResumeFSWD.pdf'

import '../App.css';

function About() {
  return (
    <div className='header'>
        <Link className='nav-name-w' to='/'>RYAN ZIEGENFUS</Link>
        <div className='nav-items-w'>
            <Link className='nav-item-w' to='/about'>ABOUT</Link>
            <a className='nav-item-w' href={pdf} target='_blank' rel="noopener noreferrer">RESUME</a>
            <Link className='nav-item-w' to='/projects'>PROJECTS</Link>
            <Link className='nav-item-w' to='/contact'>CONTACT ME</Link>
        </div>
    </div>
  );
}

export default About;